import { InputHTMLAttributes, forwardRef } from "react";
import './Field.scss'
import SInput, { type SInputProps } from "../UI/Input/SInput";


export interface IFieldProps extends InputHTMLAttributes<HTMLInputElement>, SInputProps {
  placeholder?: string | undefined
  error?: string
}

const Field = forwardRef<HTMLInputElement, IFieldProps>(({
  placeholder, error, className, type = 'text', style, ...rest }, ref) => {
  return (
    <div className={className} style={{ display: 'flex', flexDirection: 'column', width: '100%', ...style }}>
      <SInput
        ref={ref}
        type={type}
        placeholder={placeholder}
        {...rest}
      />
      <div style={{ minHeight: '18px', margin: '3px 0', fontSize: '12px', paddingLeft: '8px', }}>
        {error && <div style={{ color: 'red' }}>{error}</div>}
      </div>
    </div>
  )
})

export default Field;
